import React from 'react';
import { useWatch } from 'react-hook-form';
import { RhNumberField } from '../../../../../../../../dum';
import { IOrderRequest } from '../../../order-request-form';
import { useCalculateProductsTotal } from '../../../helpers/use-calculate-products-total';
import { FIELD_LABELS, shortLabel } from '../../../../../../../../../helpers';

const ARRAY_NAME: keyof IOrderRequest = 'order_request_products';
const KILOS_FIELD_NAME: keyof IOrderRequest['order_request_products'][number] =
    'kilos';
const GROUP_WEIGHT_FIELD_NAME: keyof IOrderRequest['order_request_products'][number] =
    'group_weight';

interface IKilosInputProps {
    index: number;
}

export function KilosInput({ index }: IKilosInputProps) {
    const INPUT_NAME = `${ARRAY_NAME}.${index}.${KILOS_FIELD_NAME}`;
    const groupWeightValue = useWatch({
        name: `${ARRAY_NAME}.${index}.${GROUP_WEIGHT_FIELD_NAME}`,
    });

    const { calculateProductsTotal } = useCalculateProductsTotal();

    return (
        <RhNumberField
            name={INPUT_NAME}
            label={shortLabel(FIELD_LABELS.kilos)}
            disableGutters
            disabled={!!groupWeightValue}
            onChange={() => {
                calculateProductsTotal();
            }}
        />
    );
}
